import {
  query,
  child,
  getDatabase,
  get,
  onValue,
  ref,
  remove,
  set,
  update,
} from 'firebase/database';
import { useEffect, useState } from 'react';

import objectToArray from '../../utils/objectToArray';
import { database } from '../config';

const databaseRef = ref(database);

export interface ITask {
  category: string;
  status: string;
  taskName: string;
  id: number;
  created: string;
  text?: string;
  image?: string;
  rank: number;
}

export const usePublicTasks = (boardId: string) => {
  const [tasks, setNewTasks] = useState<ITask[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getTasks = async () => {
    setLoading(true);
    setNewTasks([]);
    const db = getDatabase();
    const tasksQuery = query(ref(db, `boards/${boardId}`));
    try {
      const res = await get(tasksQuery);
      setLoading(false);
      return res.val();
    } catch (e) {
      console.log(e);
      setLoading(false);
      throw new Error();
    }
  };

  useEffect(() => {
    onValue(child(databaseRef, `boards/${boardId}`), (snap) => {
      !!snap?.val() && setNewTasks(objectToArray(snap?.val()));
    });
  }, [boardId]);

  useEffect(() => {
    getTasks().then((res) => {
      setNewTasks(objectToArray(res));
    });
  }, [boardId]);

  return { tasks, loading };
};

export const createTask = async (
  boardId: string,
  taskName: string,
  status: string,
  rank: number
) => {
  try {
    const created = new Date().toISOString();
    const taskId = Date.now();

    const data = {
      id: taskId,
      taskName,
      status,
      created,
      image: '',
      text: '',
      rank,
    };

    await set(child(databaseRef, `boards/${boardId}/${taskId}/`), data);

    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updateTask = async (
  boardId: string,
  taskId: number,
  taskName: string,
  status: string,
  text?: string,
  image?: string
) => {
  try {
    const data = {
      taskName,
      status,
      text: text ? text : '',
      image: image ? image : '',
    };

    await update(child(databaseRef, `boards/${boardId}/${taskId}/`), data);

    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updateStatus = async (boardId: string, taskId: number, status: string) => {
  try {
    const data = {
      status,
    };

    await update(child(databaseRef, `boards/${boardId}/${taskId}/`), data);

    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updateTaskName = async (boardId: string, taskId: number, taskName: string) => {
  try {
    const data = {
      taskName,
    };

    await update(child(databaseRef, `boards/${boardId}/${taskId}/`), data);

    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updateTaskDetails = async (boardId: string, taskId: number, text: string) => {
  try {
    const data = {
      text,
    };

    await update(child(databaseRef, `boards/${boardId}/${taskId}/`), data);

    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const deleteTask = async (boardId: string, taskId: number) => {
  try {
    await remove(child(databaseRef, `boards/${boardId}/${taskId}/`));
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updatePosition = async (boardId: string, taskId: number, rank: number) => {
  try {
    const data = {
      rank,
    };

    await update(child(databaseRef, `boards/${boardId}/${taskId}/`), data);

    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};
